'use strict';

const React = require('react');
const { MajorTeaserArea } = require('../Teaser');
const { Map } = require('immutable');
const BottomTeasers = ({editorials, currentPath}) => {

	if( (editorials || Map()).isEmpty() ) {
		return (<noscript/>);
	}

	const filteredEditorials = editorials
		.filterNot((item) => (item.get('targetUrl', '').split('/').pop() || '') === currentPath)
		.setSize(4);

	return (
			<section className="svtse_section">
				<div className="svtse_editorial__bottom-teasers">
					<div className="svtse_bottom-teasers">
						<h1 className="svtse_bottom-teasers__header">Mer från SVT</h1>
						<MajorTeaserArea model={filteredEditorials}/>
					</div>
				</div>
			</section>
	);
};

module.exports = BottomTeasers;



/** WEBPACK FOOTER **
 ** ./app/components/Editorial/EditorialBottomTeasers.js
 **/